import {
  Button,
  ButtonProps,
  Radio,
  RadioGroup,
  RadioGroupProps,
  RadioProps,
} from "@chakra-ui/react";
import React, { useMemo } from "react";

const APRadioGroup = ({ children, ...others }: RadioGroupProps) => {
  return (
    <RadioGroup
      {...others}
      sx={{
        "& .chakra-radio__control[data-checked]": {
          background: "unset",
          borderColor: "#000",
        },
        "& .chakra-radio__control[data-checked]::before": {
          width: "70%",
          height: "70%",
          background: "#EEF05D",
          border: "1px solid #000",
        },
      }}
    >
      {children}
    </RadioGroup>
  );
};

export default APRadioGroup;
